const environment={apiPrefix:'https://api-staging.backoffice.parnanoronha.nscreen.com.br/',enableMock:false};export default environment;